<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="alarmRecords">
			<template #ops>
				<el-button type="primary" v-show="form.alarmSeq === '0'" @click="handleExport">导出记录</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach" style="margin-bottom: 12px">
				<gc-advanced-filter
					ref="advancedFilter"
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-alarm-records-${tenantType}`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiGetAlarmRecordsList, 'alarm')
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiGetAlarmRecordsList, 'alarm')
						}
					"
				></gc-table>
			</div>
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="showDetailStatusDialog" width="45%">
			<EchartTable
				ref="echartTable"
				:open-type="openType"
				:info="info"
				:show="showDetailStatusDialog"
				:default-time="defaultTime"
			></EchartTable>
		</el-dialog>

		<gc-alarm-handle-dialog
			:show.sync="showHandleDialog"
			:alarmId="alarmId"
			@ops-success="getList(1, apiGetAlarmRecordsList, 'alarm')"
		></gc-alarm-handle-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import alarmMix from './mixin'
import common from '../mixins/common'
import { nameTrans } from '@/utils/index'
import { apiGetAlarmRecordsList } from '@/apis/alarm.api'
import { isBlank, isObject } from '@/utils/validate'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { apiGetDeviceTypeList } from '@/apis/account.api'
import { apiTenantIsolationOrg } from '@/apis/login.api'
import EchartTable from '@/pages/device-manage/detail/components/ChartTable.vue'
export default {
	name: 'alarmRecords',
	components: { EchartTable },
	mixins: [common, alarmMix],
	data() {
		return {
			form: {
				deviceNo: null,
				designNo: null,
				alarmSeq: '0',
				deviceTypeClassify: null,
				deviceTypeIdList: null,
				useType: null,
				installLocationList: null,
				alarmName: null,
				alarmLevel: null,
				time: null,
				alarmTypeId: null,
				userType: null,
				orgCode: null,
				alarmAckStatus: null,
				diffDay: undefined,
				processType: null,
				processUser: null,
				processDesc: null,
			},
			searchOptions: {
				installLocation: [],
				orgCode: [],
			},
			showHandleDialog: false,
			alarmId: '',
			currentAlarmSeq: '0',
			cancelRequest: true,
			columns: [],
		}
	},
	computed: {
		...mapGetters({
			needUpdateAlarmRecords: 'common/needUpdateAlarmRecords',
		}),
		userInfo() {
			return this.$store.state.user.userInfo
		},
		// 告警状态时序
		alarmSeq() {
			return this.$store.getters.dataList.alarmSeq || []
		},
		// 告警等级
		alarmLevel() {
			return this.$store.getters.dataList.alarmLevel || []
		},
		// 告警状态
		alarmStatus() {
			return this.$store.getters.dataList.alarmStatus || []
		},
		// 告警处理结果
		alarmAckStatus() {
			return this.$store.getters.dataList.alarmAckStatus || []
		},
		// 告警分类
		alarmType() {
			return this.$store.getters.dataList.alarmType || []
		},
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
		filterFields() {
			return [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'designNo',
					label: '外观编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'alarmSeq',
					label: '告警状态时序',
					type: 'select',
					props: {
						searchOption: this.searchOptions.alarmSeq,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: false,
						required: true,
					},
					defaultValue: '0',
				},
				{
					prop: 'alarmName',
					label: '告警名称',
					type: 'input',
					width: '320px',
					props: {
						needAllForSearch: true,
					},
				},
				{
					prop: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeClassify,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '0',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeId,
						filterable: true,
						multiple: true,
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '0',
				},
				{
					prop: 'userType',
					label: '客户类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.userType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '1',
				},
				{
					prop: 'orgCode',
					label: '所属组织',
					type: 'select',
					props: {
						searchOption: this.searchOptions.orgCode,
						needAllForSearch: true,
					},
					hidden: !this.userInfo || !this.userInfo.needPeekIsolation,
				},
				{
					prop: 'useType',
					label: '使用类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.useType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '0' || this.form.alarmSeq !== '0',
				},
				{
					prop: 'installLocationList',
					label: '安装位置',
					type: 'select',
					props: {
						searchOption: this.searchOptions.installLocation,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
						multiple: true,
						tip: '请先选择使用类型后再选择安装位置',
					},
					hidden: this.tenantType !== '0' || this.form.alarmSeq !== '0',
				},
				{
					prop: 'alarmTypeId',
					label: '告警分类',
					type: 'select',
					props: {
						searchOption: this.searchOptions.alarmTypeId,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'alarmLevel',
					label: '告警等级',
					type: 'select',
					props: {
						searchOption: this.searchOptions.alarmLevel,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'alarmAckStatus',
					label: '告警处理结果',
					type: 'select',
					props: {
						searchOption: this.searchOptions.alarmAckStatus,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'time',
					label: '告警时间区间',
					type: 'date',
					props: {
						datePickerType: 'datetimerange',
					},
					width: '660px',
				},
				{
					prop: 'diffDay',
					label: '逾期未处理天数',
					type: 'input-number',
				},
				{
					prop: 'processType',
					label: '处理方式',
					type: 'select',
					props: {
						searchOption: this.searchOptions.processType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'processUser',
					label: '处理人',
					type: 'input',
				},
				{
					prop: 'processDesc',
					label: '处理描述',
					type: 'input',
				},
			].filter(m => !m.hidden)
		},
		getDeviceTypeFlag() {
			return this.tenantType === '1'
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
		alarmProcessTypeMap() {
			return (this.$store.getters.dataList.alarmProcessType || []).reduce((prev, cur) => {
				prev[cur.defaultValue] = cur.name
				return prev
			}, {})
		},
	},

	mounted() {
		if (this.$route.params.alarmType) {
			this.form.alarmTypeId = this.$route.params.alarmType
			this.form.deviceTypeClassify = this.$route.params.deviceTypeClassify
		}
		if (this.tenantType !== '1') {
			this.$set(this.searchOptions, 'deviceTypeClassify', this.$store.getters.dataList.deviceTypeClassify)
			this.$set(this.searchOptions, 'useType', this.$store.getters.dataList.useTypeGas)
		}
		this.$set(this.searchOptions, 'alarmSeq', this.alarmSeq)
		this.$set(this.searchOptions, 'alarmLevel', this.alarmLevel)
		this.$set(this.searchOptions, 'alarmTypeId', this.alarmType)
		this.$set(this.searchOptions, 'userType', this.$store.getters.dataList.userType || [])
		this.$set(this.searchOptions, 'alarmAckStatus', this.$store.getters.dataList.alarmAckStatus || [])
		this.$set(this.searchOptions, 'processType', this.$store.getters.dataList.alarmProcessType || [])
		if (this.userInfo && this.userInfo.needPeekIsolation) {
			this.getOrganizationList()
		}
		this.getList(1, apiGetAlarmRecordsList, 'alarm')
	},

	watch: {
		'form.deviceTypeClassify': {
			handler(newVal) {
				if (newVal) {
					this.form.deviceTypeIdList = null
				}
				this.queryDeviceTypeList()
			},
			immediate: true,
		},

		'form.useType'(newVal) {
			if (newVal) {
				this.searchOptions.installLocation = (this.$store.getters?.dataList?.installLocationGas || []).filter(
					m => m.defaultValue[0] === newVal,
				)
			} else {
				this.searchOptions.installLocation = []
			}
			this.form.installLocationList = null
		},

		tenantType: {
			handler() {
				const columns = [
					{
						key: 'deviceNo',
						name: '设备通讯编号',
						fixed: 'left',
						tooltip: true,
						dragDisable: true,
						disabledSelect: true,
					},
					{
						key: 'designNo',
						name: '外观编号',
						tooltip: true,
					},
					{
						key: 'userTypeName',
						name: '客户类型',
						hidden: this.tenantType !== '1',
					},
					{
						key: 'orgName',
						name: '所属组织',
						tooltip: true,
					},
					{
						key: 'userNo',
						name: '用户号',
					},
					{
						key: 'username',
						name: '客户/站点名称',
						tooltip: true,
					},
					{
						key: 'useType',
						name: '使用类型',
						tooltip: true,
					},
					{
						key: 'installLocation',
						name: '安装位置',
						tooltip: true,
					},
					{
						key: 'phone',
						name: '联系电话',
					},
					{
						key: 'address',
						name: '安装地址',
						tooltip: true,
					},
					{
						key: 'deviceTypeName',
						name: '设备类型',
						tooltip: true,
					},
					{
						key: 'alarmType',
						name: '告警分类',
					},
					{
						key: 'alarmName',
						name: '告警名称',
						tooltip: true,
					},
					{
						key: 'alarmLevel',
						name: '告警等级',
						render: (h, row) => {
							let alarmIcon = []
							if (!isBlank(row.alarmLevel)) {
								for (let i = 0; i < row.alarmLevel; i++) {
									alarmIcon.push(
										h('i', {
											class: 'iconfont icon-caution',
											style: {
												'margin-left': '6px',
												color: '#EC6B60',
												'font-size': '12px',
											},
										}),
									)
								}
							}
							return h('div', [
								h(
									'span',
									{
										style: {
											color: '#EC6B60',
										},
									},
									nameTrans(row.alarmLevel, this.alarmLevel),
								),
								...alarmIcon,
							])
						},
					},
					{
						key: 'alarmStatus',
						name: '告警状态',
						render: (h, row) => {
							return h('span', {}, [
								h('i', {
									class: row.alarmStatus == 0 ? 'dot-error' : 'dot-message',
								}),
								nameTrans(row.alarmStatus, this.alarmStatus),
							])
						},
					},
					{
						key: 'alarmAckStatus',
						name: '告警处理结果',
						render: (h, row) => {
							return h('span', null, nameTrans(row.alarmAckStatus, this.alarmAckStatus) || '--')
						},
					},
					{
						key: 'createTime',
						name: '告警时间',
						width: '160',
					},
					{
						key: 'diffDay',
						name: '逾期未处理天数',
					},
					{
						key: 'alarmDetail',
						name: '告警信息',
						render: (h, row) => {
							const alarmDetailArr = !isBlank(row.alarmDetail) ? row.alarmDetail.split('\n') : []
							const childList = []
							if (alarmDetailArr.length > 0) {
								alarmDetailArr.forEach(item => {
									childList.push(h('div', {}, item))
								})
							}
							return h('div', {}, !isBlank(row.alarmDetail) ? childList : '--')
						},
					},
					{
						key: 'clearTime',
						name: '告警恢复时间',
						width: 180,
					},
					{
						key: 'processType',
						name: '处理方式',
						render: (h, row) => {
							return h('span', null, this.alarmProcessTypeMap[row.processType] || '--')
						},
					},
					{
						key: 'processUser',
						name: '处理人',
					},
					{
						key: 'processDesc',
						name: '处理描述',
						tooltip: true,
					},
					{
						key: 'oprate',
						name: '操作',
						minWidth: 300,
						render: (h, row) => {
							const childList = [
								row.isPressHigh === 1
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => this.showPressure(row),
												},
											},
											'压力查看',
									  )
									: '',
								this.currentAlarmSeq === '0' &&
								row.alarmAckStatus !== 2 &&
								row.manualHandleSupport === 1 &&
								this.$has('monitor:run:alarm-record:modify')
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => {
														this.handleAlarm(row)
													},
												},
											},
											'处理登记',
									  )
									: '',
								...[
									[39, 40, 55, 56, 57].includes(row.eventId)
										? h(
												'el-button',
												{
													props: {
														type: 'text',
														size: 'medium',
													},
													on: {
														click: () => this.showDetailStatus(row),
													},
												},
												'数据展示',
										  )
										: [],
								],
								this.$has('monitor:device:account:record:alarm')
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => {
														this.$router.push({
															name: 'deviceDetail',
															query: {
																deviceId: row.deviceId,
																deviceType: row.deviceTypeId,
															},
															params: {
																name: 'AlarmRecord',
															},
														})
													},
												},
											},
											'查看详情',
									  )
									: '',
								row.woNo
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => {
														this.navigatorWorkNoDetails(row.woId)
													},
												},
											},
											'工单详情',
									  )
									: '',
							]
							const hasVNode = childList.some(item => isObject(item))
							return h('div', {}, hasVNode ? childList : '/')
						},
						fixed: 'right',
					},
				]
				this.columns = columns
			},
			immediate: true,
		},
	},

	methods: {
		...mapMutations({
			setUpdateAlarmRecords: 'common/SET_UPDATE_ALARM_RECORDS',
		}),

		// 高级筛选查询
		handleFilterSearch() {
			this.getList(1, apiGetAlarmRecordsList, 'alarm')
		},

		// 高级筛选重置
		handleFilterReset() {
			this.getList(1, apiGetAlarmRecordsList, 'alarm')
		},

		// 获取组织列表
		async getOrganizationList() {
			try {
				const data = await apiTenantIsolationOrg()
				this.$set(
					this.searchOptions,
					'orgCode',
					(data || []).map(m => {
						return {
							label: m.name,
							value: m.orgCode,
						}
					}),
				)
			} catch (error) {
				this.searchOptions.orgCode = []
			}
		},

		async queryDeviceTypeList() {
			const data = await apiGetDeviceTypeList({
				tenantId: this.tenantId,
				deviceTypeClassify: this.form.deviceTypeClassify,
			})
			this.$set(
				this.searchOptions,
				'deviceTypeId',
				(data.records || []).map(item => {
					return {
						value: item.deviceTypeId,
						label: item.deviceTypeName,
					}
				}),
			)
		},

		apiGetAlarmRecordsList,

		handleAlarm(row) {
			this.alarmId = row.alarmId
			this.showHandleDialog = true
		},

		handleExport() {
			if (!this.tableData.length) return this.$message.warning('暂无表格数据')
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/run/alarm/export/excel',
				fileName: '告警记录.xlsx',
				data: {
					...this.form,
					alarmStartTime: this.form.time ? this.dayjs(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss') : null,
					alarmEndTime: this.form.time ? this.dayjs(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss') : null,
					orgCode: [this.form.orgCode].filter(Boolean),
				},
			}
			exportReport(data, 'excel', '', this.$toast)
		},

		navigatorWorkNoDetails(workId) {
			window.open(`${window.ETBC_WORKNO_DOMAIN}&workId=${workId}`)
		},
	},

	activated() {
		if (this.$route.params?.update || this.needUpdateAlarmRecords) {
			this.setUpdateAlarmRecords(false)
			this.form = this.$options.data().form
			this.getList(1, apiGetAlarmRecordsList, 'alarm')
		}
		if (this.$route.params.alarmType) {
			this.form = this.$options.data().form
			this.form.alarmTypeId = this.$route.params.alarmType
			this.form.deviceTypeClassify = this.$route.params.deviceTypeClassify
			this.getList(1, apiGetAlarmRecordsList, 'alarm')
		}
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
</style>
